import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { AuthService } from '../services/auth.service';
import { MenuService } from '../services/menu.service';
import { MenuItems } from '../models/menuItens.model';

import { LeadModalComponent } from '../pages/modal/lead-modal/lead-modal.component';
import { UserModal } from '../pages/modal/user-modal/user-modal';
import { VendaBalcaoCupomModal } from '../pages/modal/venda-balcao-cupom-modal/venda-balcao-cupom-modal';

interface HierarchicalMenuItem extends MenuItems {
  children: HierarchicalMenuItem[];
  expanded?: boolean;
}


@Component({
  selector: 'app-home',
  templateUrl: './home.html',
  styleUrl: './home.css',
  standalone: true,
  imports: [CommonModule, RouterModule, LeadModalComponent, UserModal, VendaBalcaoCupomModal],
  animations: [
    trigger('accordion', [
      state('collapsed', style({ height: '0px', overflow: 'hidden' })),
      state('expanded', style({ height: '*', overflow: 'auto' })),
      transition('expanded <=> collapsed', [
        animate('300ms ease-in-out')
      ]),
    ]),
  ]
})

export class HomeComponent implements OnInit {
  menuItems: MenuItems[] = [];
  processedMenuItems: HierarchicalMenuItem[] = [];
  isUserModalOpen = false;
  isLeadModalOpen = false;
  isVendaBalcaoOpen = false;
  isSidebarOpen = false;
  isSidebarCollapsedDesktop = false;

  dropDownMenuItens: string [] = ['Novo orçamento', 'Nova venda', 'Nova despesa']
  isDropDownMenuVisible: boolean = false;
  


  constructor(private authService: AuthService, private menuService: MenuService, private router: Router) { }

  ngOnInit(): void {
    this.authService.permissoes$.subscribe(permissoes => {
      if (permissoes) {
        this.menuService.getMenuItems(permissoes).subscribe(menuItems => {
          this.menuItems = menuItems;
          this.processedMenuItems = this.buildMenuTree(this.menuItems);

        });
      }
    });
  }

 

  home(): void {
    this.router.navigate(["/home"]);
    this.isSidebarOpen = false;
  }

  handleMenuClick(item: HierarchicalMenuItem): void {
    if (item.children && item.children.length > 0) {
      this.toggleMenu(item);
    } else {
      this.router.navigate(["/home", ...item.slug.split("/")]);
      this.isSidebarOpen = false;
    }
  }

  buildMenuTree(items: MenuItems[]): HierarchicalMenuItem[] {
    const itemMap = new Map<number, HierarchicalMenuItem>();
    const roots: HierarchicalMenuItem[] = [];

    items.forEach(item => {
      itemMap.set(item.id, { ...item, children: [], expanded: false });
    });

    items.forEach(item => {
      const mappedItem = itemMap.get(item.id);
      if (mappedItem) {
        if (item.parentId !== 0) {
          const parent = itemMap.get(item.parentId);
          if (parent) {
            parent.children.push(mappedItem);
          }
        } else {
          roots.push(mappedItem);
        }
      }
    });

    const sortItems = (items: HierarchicalMenuItem[]) => {
      items.sort((a, b) => a.posicao - b.posicao);
      items.forEach(item => {
        if (item.children.length > 0) {
          sortItems(item.children);
        }
      });
    };

    sortItems(roots);

    return roots;
  }

  toggleMenu(item: HierarchicalMenuItem): void {
    item.expanded = !item.expanded;
  }

  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  toggleDesktopSidebar(): void {
    if (window.innerWidth > 1024) {
      this.isSidebarCollapsedDesktop = !this.isSidebarCollapsedDesktop;
    }
  }


  getMenuIcon(item: HierarchicalMenuItem): string {
    return item.metadata?.['icone'] ?? 'bi-circle';
  }

  userModal(): void {
    this.isUserModalOpen = !this.isUserModalOpen;
  }

  vendaBalcao(): void {
    this.isVendaBalcaoOpen = true;
    this.isSidebarOpen = false;
  }

  closeVendaBalcao(vendaConcluida: boolean): void {
    this.isVendaBalcaoOpen = false;
    if (vendaConcluida) {
      this.router.navigate(['/home', 'venda-venda']);
    }
  }


  leadsModal(): void {
    this.isLeadModalOpen = !this.isLeadModalOpen;
  }

   logout(): void {
    this.isUserModalOpen = !this.isUserModalOpen;
    this.authService.logout();
    this.router.navigate(['/login']);
  }


}
